const PUBLIC_PROPOSAL_WIZARD_STEP_DEFS = [
  { id: 'items', title: 'Itens e Valores' },
  { id: 'delivery', title: 'Endereço de Entrega' },
  { id: 'contract', title: 'Contrato' },
  { id: 'acceptance-payment', title: 'Aceite e Pagamento' },
] as const;

type PublicProposalWizardStepId = (typeof PUBLIC_PROPOSAL_WIZARD_STEP_DEFS)[number]['id'];

export const DEFAULT_PUBLIC_STEP: PublicProposalWizardStepId = 'items';

interface ResolvePublicProposalStepOptions {
  includeAcceptancePayment: boolean;
  contractSigned: boolean;
}

export function resolvePublicProposalStep(
  requestedStep: string | null,
  { includeAcceptancePayment, contractSigned }: ResolvePublicProposalStepOptions,
): PublicProposalWizardStepId {
  const stepDefs = getPublicProposalWizardStepDefs(includeAcceptancePayment);
  const requested = stepDefs.find((step) => step.id === requestedStep)?.id ?? DEFAULT_PUBLIC_STEP;

  if (requested === 'acceptance-payment' && !contractSigned) {
    return 'contract';
  }

  return requested;
}

export function buildPublicProposalWizardSteps(
  currentStep: PublicProposalWizardStepId,
  includeAcceptancePayment: boolean,
  contractSigned: boolean,
  hasImmediatePayment = false,
) {
  const stepDefs = getPublicProposalWizardStepDefs(includeAcceptancePayment);
  const currentIndex = stepDefs.findIndex((step) => step.id === currentStep);
  const safeIndex = currentIndex < 0 ? 0 : currentIndex;
  const contractStepIndex = stepDefs.findIndex((step) => step.id === 'contract');

  return stepDefs.map((step, index) => {
    const isActive = index === safeIndex;
    const isCompleted = index < safeIndex;
    let isDisabled = index > safeIndex;

    if (
      step.id === 'acceptance-payment' &&
      !contractSigned &&
      index > contractStepIndex &&
      contractStepIndex >= 0
    ) {
      isDisabled = true;
    }

    if (step.id === 'contract' && contractSigned) {
      isDisabled = false;
    }

    return {
      id: step.id,
      title:
        step.id === 'acceptance-payment'
          ? hasImmediatePayment
            ? 'Aceite e Pagamento'
            : 'Aceite'
          : step.title,
      href: `?step=${step.id}`,
      completed: isCompleted,
      disabled: isDisabled,
      isActive,
    };
  });
}

function getPublicProposalWizardStepDefs(includeAcceptancePayment: boolean) {
  return includeAcceptancePayment
    ? PUBLIC_PROPOSAL_WIZARD_STEP_DEFS
    : PUBLIC_PROPOSAL_WIZARD_STEP_DEFS.filter((step) => step.id !== 'acceptance-payment');
}
